import { Command } from 'commander'

import { PublishCommand } from '@/domains/registry/publish'

import { DeleteCommand } from './delete'
import { ListCommand } from './list'
import { UpdateCommand } from './update'

const registryCommands = [
  PublishCommand,
  UpdateCommand,
  DeleteCommand,
  ListCommand,
]

const registryDomain = new Command('registry')

registryDomain.description('Manage your scalar registry')
registryCommands.forEach((command) => registryDomain.addCommand(command()))

export default registryDomain
